"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modelShowInterpreter = void 0;
var tslib_1 = require("tslib");
var utils_1 = require("@morphic-ts/common/lib/utils");
var intersections_1 = require("./model/intersections");
var newtype_1 = require("./model/newtype");
var object_1 = require("./model/object");
var primitives_1 = require("./model/primitives");
var recursive_1 = require("./model/recursive");
var refined_1 = require("./model/refined");
var set_1 = require("./model/set");
var str_map_1 = require("./model/str-map");
var tagged_unions_1 = require("./model/tagged-unions");
var unions_1 = require("./model/unions");
var unknown_1 = require("./model/unknown");
tslib_1.__exportStar(require("./hkt"), exports);
/**
 *  @since 0.0.1
 */
var allModelShow = function () {
    return utils_1.merge(unions_1.showUnionInterpreter(), refined_1.showRefinedInterpreter(), newtype_1.showNewtypeInterpreter(), unknown_1.showUnknownInterpreter(), primitives_1.showPrimitiveInterpreter(), intersections_1.showIntersectionInterpreter(), object_1.showObjectInterpreter(), tagged_unions_1.showTaggedUnionInterpreter(), recursive_1.showRecursiveInterpreter(), set_1.showSetInterpreter(), str_map_1.showStrMapInterpreter());
};
/**
 *  @since 0.0.1
 */
exports.modelShowInterpreter = allModelShow;
